import React from 'react';
import { Image } from 'react-konva';
class URLImage extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            image: null
        };
    }
    componentDidMount() {
        this.loadImage();
    }
    componentDidUpdate(oldProps) {
        if (oldProps.src !== this.props.src) {
            this.loadImage();
        }
    }
    componentWillUnmount() {
        this.image.removeEventListener('load', this.handleLoad.bind(this));
    }
    loadImage() {
        this.image = new window.Image();
        this.image.src = this.props.src;
        this.image.addEventListener('load', this.handleLoad.bind(this));
    }
    handleLoad() {
        this.setState({
            image: this.image
        });
        if (this.props.onload) this.props.onload();
    };
    render() {
        return (
            <Image
                x={this.props.x}
                y={this.props.y}
                rotation={this.props.rotation}
                width={this.props.width}
                height={this.props.height}
                image={this.state.image}
                dragBoundFunc={this.props.dragBoundFunc}
                onDragEnd={this.props.onDragEnd}
                onClick={this.props.onClick}
                draggable={this.props.draggable}
                offsetX={this.props.offsetX}
                offsetY={this.props.offsetY}
                scaleX={this.props.scaleX}
                scaleY={this.props.scaleY}
                offset={this.props.offset}                
                ref={node => {
                    this.imageNode = node;
                }}
            />
        );
    }
}
export default URLImage;